import React from 'react';
import { ReactComponent as Eclipse } from './assets/eclipse.svg';
import { Container, FullScreenContainer } from './styles';

export const Loading: React.FC<{ fullScreen?: boolean }> = ({
  fullScreen = false,
}) => {
  if (fullScreen) {
    return (
      <FullScreenContainer>
        <Eclipse className="svg" />
      </FullScreenContainer>
    );
  }

  return (
    <Container>
      <Eclipse className="svg" />
      <h6 className="ifpa-semibold">
        Estamos carregando <br /> alguns dados...
      </h6>
      <p className="p2 ifpa-medium">
        Esse processo pode levar alguns <br /> segundos, continue na página
      </p>
    </Container>
  );
};
